export * from './lib/match';
export * from './lib/apply-regex-list';



/** WEBPACK FOOTER **
 ** ./~/syntaxhighlighter-match/index.js
 **/